module.exports = __webpack_public_path__ + "images/fde547709d4352453721b4ca9ed32d41.webp";